import React from 'react'

import ReactDOM from 'react-dom'
import Page from '../../Page'
import Form from '../../../components/form/Form';
import ProfileItemForm from "./ProfileItemForm";
import {Alert} from 'antd';
import { TalentAppCard } from './TalentAppCard';

export default class TalentAppStep extends Page {


    formRef = React.createRef();

    static events() {
        return {
            "TalentApp@Submit": (component) => {

                let elem = component.invalidFields() || component.invalidNestedFields();

                if(elem) {
                    const node = ReactDOM.findDOMNode(elem);

                    $('html, body').animate({scrollTop: $(node).offset().top}, 1000);
                }

            }
        }
    }

    static path = null;
    /**
     * The title shown on the form
     */
    static StepTitle = null;
    /**
     * The subtitle shown on the form
     */
    static StepSubtitle = null;
    /**
     * The start page info tile
     */
    static StepInfo = null;

    /**
     * Show or hide review step info
     */
    static HideReview = false
    /**
     * The Step Section to be grouped in after application approval
     */
    static StepSection = null;

    static ValidationMethodName = null;

    static LastUpdatedMethod = null;

    /**
     * show completion icon on sidebar
     */
    static NeedsCompletion = (user) => {
        return true;
    };

    /**
     * show completion icon on sidebar
     */
    missingValidation() {
        return null;
    }

    /**
     * show completion icon on sidebar
     */
    // alertMissingValidationMessage = () => {
    //     console.log('this.constructor.StepNeedsValidation(this.props.user)', this.constructor.StepNeedsValidation(this.props.user))
    //     console.log('!this.constructor.hasCompleted(this.props.user)', !this.constructor.hasCompleted(this.props.user))
    //     console.log('this.props.user?.isApplicationApproved()', this.props.user?.isApplicationApproved())
    //     console.log('this.props.user?.status', this.props.user?.status)
    //     if (this.constructor.StepNeedsValidation(this.props.user) && !this.constructor.hasCompleted(this.props.user) && this.props.user?.isApplicationApproved() && this.props.user?.status === 'Building Profile') {
    //         let message = this.missingValidation();
    //
    //         console.log('alertMissingValidationMessage', message)
    //         if (!message) {
    //             return;
    //         }
    //         const key = `open${Date.now()}`;
    //         const btn = (
    //             <button className="btn btn-dark" onClick={() => notification.close(key)}>
    //                 Confirm
    //             </button>
    //         );
    //
    //         return notification.open({
    //             message: 'Missing Profile Requirements',
    //             description: (
    //                 <div className="flex flex-col gap-2">
    //                     <ul className="list-disc">
    //                         {TB.map(message, item => (
    //                             <li className="text-danger font-medium text-xs" key={item}>{item}</li>
    //                         ))}
    //                     </ul>
    //                 </div>
    //             ),
    //             btn,
    //             key,
    //             type: "warning",
    //         });
    //     }
    // };


    componentDidMount() {
        super.componentDidMount();
        // this.alertMissingValidationMessage()
        this.props.handleEditing(false);
    }

    /**
     * Show brief details for user
     */
    static ProfileSectionSummary = (user) => {
        return '';
    };

    /**
     * The step needed before editing
     */
    static StepNeedsValidation(user) {
        let validationCallback = this.ValidationMethodName;
        if (!validationCallback && this.StepTitle) {
            validationCallback = `validate${String(this.StepTitle)
                .replace('&', '').replace(/\s/g, '')}`
        }

        if (TB.isDefined(user[validationCallback]) && !user[validationCallback]()) {
            return this;
        }

        return false;
    };

    /**
     * Check if we should prevent application from saving and show alert
     */
    static async getValidProps(user) {
        let validationCallback = this.ValidationMethodName;
        if (!validationCallback && this.StepTitle) {
            validationCallback = `validate${String(this.StepTitle)
                .replace('&', '').replace(/\s/g, '')}`
        }

        if (TB.isDefined(user[validationCallback])) {
            return user[validationCallback]();
        }
        return false
    };

    static getPath(prefix = '/talent/application') {
        return `${prefix}${this.path}`
    }

    /**
     * @param {User} user
     * @returns {Object}
     */
    static reviewMapping(user) {
        return {}
    }

    /**
     * The fields mapping for the form
     */
    static showFormButtons() {
        return true
    }

    /**
     * The first invalid field
     */
    invalidFields() {
        if (!this.formRef.current) {
            return false
        }
        let invalid = this.formRef.current.forceValidate() || this.invalidNestedFields();

        if(invalid) {
            const node = ReactDOM.findDOMNode(invalid);

            $('html, body').animate({scrollTop: $(node).offset().top}, 1000);
        }
        return invalid || this.isEditingChildForm();
    }

    async handleInputResponseError(request) {

        // console.log('handleInputResponseError', this.childRefs);

        try {
            if (this.formRef.current) {
                let invalid = await this.formRef.current.handleInputResponseError(request)
                if(invalid) {
                    const node = ReactDOM.findDOMNode(invalid);

                    $('html, body').animate({scrollTop: $(node).offset().top}, 1000);
                    return false;
                }
            }
        }catch (e) {
            console.warn('ERROR: handleInputResponseError', e);
        }

        try {
            let formErrors = {...request.response.data.error.data};
            let nestFormErrors = {};
            let invalidInputs = [];

            TB.map(formErrors, (messages, errorKey) => {
                TB.set(nestFormErrors, errorKey, messages);
            });

            await TB.map(nestFormErrors, async(childForms, formType) => {
                await TB.map(childForms, async(childFormErrors, childFormIndex) => {
                    let childRef = this.childRefs[formType]?.[childFormIndex]?.current;

                     childFormErrors = TB.reduce(childFormErrors, (result, messages, key) => {
                        result[key] = messages.map(message => TB.replace(message,`${formType}.${childFormIndex}.${key}`, key.replace('_', ' ')));
                        return result;
                    }, {});

                    if (childRef) {
                        if (childRef.formRef) {
                            try {
                                await childRef.formRef.current.updateInputsWithError(childFormErrors);
                                let invalid = childRef.formRef.current.forceValidate();
                                if (invalid) {
                                    invalidInputs.push(invalid);
                                }
                            }catch (e) {
                                console.warn(`ERROR: ${e}`);
                            }
                        }else {
                            try {
                                await childRef.updateInputsWithError?.(childFormErrors);
                                let invalid = childRef.forceValidate?.();
                                if (invalid) {
                                    invalidInputs.push(invalid);
                                }
                            }catch (e) {
                                console.warn(`ERROR: ${e}`);
                            }
                        }

                    }
                })
            });

            if (invalidInputs.length) {
                let toScroll = [];
                invalidInputs.map(input => {
                    const node = ReactDOM.findDOMNode(input);

                    if(node) {
                        toScroll.push($(node).offset().top);
                    }
                })
                $('html, body').animate({scrollTop: TB.min(toScroll)}, 1000);

            }
        }catch (e) {
            console.warn('ERROR: handleInputResponseError', e)
        }

    }

    /**
     * The fields mapping for the form
     */
    formFields = () => {
        return []
    };

    /**
     * [Constructor]
     *
     * @param {Object} props
     * @returns {FormPage}
     */
    constructor(props) {
        super(props);
        this.childRefs = {};
    }


    /**
     * Handles form submit button clicks when form is valid
     *
     * @returns void
     * @param params
     */
    async onSubmit(params) {
        // TB.log().object(
        //     'Talent Signup @ onSubmit', {...params}
        // );

        this.props.onSubmit({
            params
        });
    }

    invalidNestedFields() {

        if (Object.keys(this.childRefs)?.length) {
            TB.map(this.childRefs, (childForms = [], formType) => {

                childForms.map(form => {

                    let invalid = form?.current?.forceValidate();
                    if (invalid) {
                        return invalid;
                    }
                })
            })
        }
        if (this.nestedFormRefs?.length) {
            this.nestedFormRefs.map(form => {

                let invalid = form?.current?.forceValidate();
                if (invalid) {
                    return invalid;
                }
            })
        }
        return false;
    }

    /**
     * Handles form change
     *
     * @returns void
     * @param params
     */
    async onChange(params) {
        return this.props.onChange(params)
    }

    /**
     * Update prop array at index
     *
     * @returns {Object}
     * @param propName
     * @param index
     * @param model
     */
    updateModelProp = (propName, index, model) => {

        let user = TB.pick({...this.props.user}, propName);

        if (!TB.isEmpty(model)) {
            let updatedModel = {...model};
            for (let [key, value] of Object.entries(updatedModel)) {
                if (TB.isDefined(value) && value instanceof Date) {
                    // console.log('SettingDateField', key);
                    updatedModel[key] = value.toISOString();
                }
                // if (TB.isDefined(value) && typeof value === 'boolean') {
                //     console.log('SettingBooleanField', key);
                //     updatedModel[key] = value ? 1 : 0;
                // }
            }

            user = TB.set(user, `${propName}[${index}]`, updatedModel);
        } else {
            TB.unset(user, `${propName}[${index}]`);
        }

        user[propName] = user[propName].filter(params => !TB.isEmpty(params));

        return user;
    }

    /**
     * Handles mapping
     *
     * @returns void
     * @param params
     */
    mapping(params) {
        return params
    }


    /**
     * Render the form
     *
     * @returns {Form}
     */
    render() {
        return (
            <div className="talent-application px-4 md:px-8 xl:w-10/12 w-full mr-auto ml-0">
                {this.renderTitle()}

                {this.formFields().length > 0 && (
                    <TalentAppCard>
                        <TalentAppCard.Section className="[&_.form-container]:!p-0">
                            <Form
                                ref={this.formRef}
                                showRequired
                                title={null}
                                subtitle={null}
                                submitButton={false}
                                onSubmit={null}
                                model={this.props.user}
                                mapping={model => this.mapping(model)}
                                onChange={(model) => {
                                    if (this.props.disabled) return;

                                    return this.onChange(model);
                                }}
                                fields={this.formFields()}
                                isDisabled={this.props.disabled}
                            >

                            </Form>
                        </TalentAppCard.Section>
                    </TalentAppCard>
                )}
                {/* {this.formFields().length > 0 && (
                    <div className="talent-role-form">
                        <Form
                            ref={this.formRef}
                            showRequired
                            title={null}
                            subtitle={null}
                            submitButton={false}
                            onSubmit={null}
                            model={this.props.user}
                            mapping={model => this.mapping(model)}
                            onChange={(model) => {
                                if (this.props.disabled) return;

                                return this.onChange(model);
                            }}
                            fields={this.formFields()}
                            isDisabled={this.props.disabled}>

                        </Form>
                    </div>
                )} */}

                {this.renderFormFooter()}
            </div>
        );
    }

    renderFormFooter() {
        return null;
    }

    renderTitle() {
        return (
            <div className="form-title-section">
                <div className="step-title-content">
                    <div>
                        <div className="flex flex-col items-start gap-y-2 md:flex-row md:items-center mb-3">
                            <div className="flex flex-row items-center">
                                <h3 className="form-title !mb-0">
                                    {this.constructor.StepTitle}
                                </h3>

                                {this.renderLastUpdated()}
                            </div>

                            {this.renderRequirements()}
                        </div>

                        {this.renderSubtitle()}
                    </div>
                </div>
            </div>
        )
    }

    renderSubtitle() {
        if (!this.constructor.StepSubtitle) {
            return null;
        }

        return (
            <h5 className="form-subtitle">
                {this.constructor.StepSubtitle}
            </h5>
        )
    }


    /*********************************************
     * Child form methods
     *********************************************/

    /**
     * Render child form and attach Ref for validation
     */
    renderChildForm({
        formTitle,
        displayName,
        header,
        headerHint,
        ChildFormComponent = ProfileItemForm,
        userProp,
        onSubmit,
        formProps = {},
        showHint = false,
        maxRelations, // hide add more button if this is reached
    }) {

        let relations = this.props.user[userProp] || [];
        if (!this.childRefs[userProp]) {
            this.childRefs[userProp] = [];
        }
        let childType = TB.snakeCase(userProp);
        const onFormSubmit = async (index, model) => {

            if (onSubmit) {
                return onSubmit(index, model);
            }
            return this.onSubmitChildForm(index, model, userProp)
        }
        return (
            <div>
                {header && (
                    <div className="form-title-section">
                        <div className="step-title-content">
                            <div>
                                <h5 className="form-subtitle">
                                    {header}
                                </h5>
                                {headerHint && (
                                    <h4 className="form-subtitle-hint">
                                        {headerHint}
                                    </h4>
                                )}
                            </div>
                        </div>
                    </div>
                )}
                {relations.map((relation, index) => {
                    if (!this.childRefs[userProp][index]) {
                        this.childRefs[userProp][index] = React.createRef();
                    }
                    let childIndexName = this.childFormIndexName(index, childType);
                        let relationProps = {model: relation, [TB.singularize(userProp)]: relation};

                        return (
                            <div
                                key={childType + (relation?.id || relation?.name || ('not-set' + index))}
                                id={`${userProp}-form-${(relation?.id || relation?.name || ('not-set' + index))}`}>
                                <ChildFormComponent
                                    key={childType + (relation?.id || relation?.name || ('not-set' + index))}
                                    {...this.props}
                                    ref={this.childRefs[userProp][index]}
                                    itemIndex={index}
                                    formTitle={(formTitle || `${displayName}`) + ` #${index + 1}`}
                                    disabled={this.props.disabled}
                                    onSubmit={model => onFormSubmit(index, model)}
                                    onChange={(model) => {
                                        if (this.props.disabled) return;

                                        return this.onChange(model);
                                    }}
                                    canEdit={
                                        !this.props.disabled && (
                                            !this.isEditingChildForm() ||
                                            this.isChildFormEditActive(
                                                childIndexName
                                            )
                                        )
                                    }
                                    isEditing={this.isChildFormEditActive(
                                        childIndexName
                                    )}
                                    onEditing={isEditing => this.handleChildFormEdit(
                                        childIndexName,
                                        isEditing
                                    )}
                                    {...formProps}
                                    {...relationProps}
                                />
                            </div>
                        )
                    }
                )}

                {showHint && relations.length === 0 && (
                    <h3 className="talent-form-warning">
                        <i className="fas fa-exclamation-circle"/> You must add at least one {String(displayName)
                        .toLowerCase()}
                    </h3>
                )}

                {/* <div
                    style={ChildFormComponent.getFormStyle?.() || {}}
                    className={'white-panel talent-role-panel ' + (this.isEditingChildForm() && 'no-edit')}
                >
                    {ChildFormComponent.renderIcon?.() || null}

                    {relations.length >= maxRelations ? (
                        <p className="text-sm">You've reached the max amount of {TB.pluralize(displayName.toLowerCase())} ({maxRelations})</p>
                    ):(
                        <button
                            disabled={this.props.disabled}
                            className="btn btn-outline-dark" onClick={() => this.addNewArrayProp(userProp)}>
                            Add {displayName}{relations.length > 0 && ` #${relations.length + 1}`} <i className="ml-1 fa fa-plus"/>
                        </button>
                    )}
                </div> */}

                <div className={'mb-6 ' + (this.isEditingChildForm() && 'no-edit')}>
                    <TalentAppCard className="relative">
                        <TalentAppCard.Section>
                            {ChildFormComponent.renderIcon?.() || null}

                            {relations.length >= maxRelations ? (
                                <p className="text-sm">You've reached the max amount of {TB.pluralize(displayName.toLowerCase())} ({maxRelations})</p>
                            ):(
                                <button
                                    disabled={this.props.disabled}
                                    className="btn btn-outline-dark" onClick={() => this.addNewArrayProp(userProp)}>
                                    Add {displayName}{relations.length > 0 && ` #${relations.length + 1}`} <i className="ml-1 fa fa-plus"/>
                                </button>
                            )}
                        </TalentAppCard.Section>
                    </TalentAppCard>
                </div>
            </div>
        )
    }

    /**
     * Check if current form is being edited
     */
    isChildFormEditActive(index) {
        return this.isEditingChildForm() && index === this.state.editingIndex
    }

    /**
     * Check if another form is being edited
     */
    isEditingChildForm() {
        return TB.isDefined(this.state.editingIndex);
    }

    /**
     * Generate unique index name based on type
     *
     * @returns string
     * @param index
     * @param type
     */
    childFormIndexName(index, type) {
        if (!type) {
            type = TB.slugify(this.constructor.StepTitle);
        }

        return `${type}_${index}`
    }

    /**
     * Handles nested child form edit
     *
     * @returns void
     * @param editingIndex
     * @param isEditing
     */
    handleChildFormEdit = async (editingIndex, isEditing) => {

        if (!isEditing) {
            editingIndex = undefined;
        }

        await this.promisedState({editingIndex});
        await this.props.onEditingChildForm(this.isEditingChildForm())
    }

    /**
     * Add new model to array prop
     *
     * @returns void
     */
    addNewArrayProp = async (propName) => {

        let models = TB.get({...this.props.user}, propName, []);
        models.push({});

        await this.props.onChange({[propName]: models});
        return this.handleChildFormEdit(
            this.childFormIndexName(models.length - 1, propName),true
        )
    }

    /**
     * Update model and sync change. Clear editing index
     *
     * @returns void
     */
    onSubmitChildForm = async(index, model, propName) => {
        let user = await this.updateModelProp(propName, index, model);

        await this.onChange(user);

        await this.handleChildFormEdit(undefined, false);

        return this.props.onSubmitChild(this.props.user);
    }

    renderLastUpdated = () => {

        let method = this.constructor.LastUpdatedMethod;

        if (!method) {
            return null;
        }
        let lastUpdated = this.props.user?.[method]?.();
        const isCompleted = this.constructor.hasCompleted(this.props.user);

        if (!isCompleted || !TB.isInteger(lastUpdated)) {
            return null;
        }

        return (
            <div className="header-last-updated">
                <p className={lastUpdated > 30 ? 'text-danger' : ''}>
                    <i className="fas fa-clock"/>
                    &nbsp; {`${lastUpdated} day${(lastUpdated === 1) ? '' : 's'} ago`}
                </p>
            </div>
        )
    }

    /*********************************************
     * Requirement Messaging
     *********************************************/
    /**
     * Are requirements optional
     *
     * @returns boolean
     */
    isRequirementOptional() {
        return false;
    }
    /**
     * Are requirements completed
     *
     * @returns boolean
     */
    isRequirementComplete() {
        return true;
    }
    /**
     * Requirement messaging
     *
     * @returns string
     */
    requirementInfo() {
        return '';
    }
    /**
     * Show requirements in top right alert box
     *
     * @returns JSX.Element
     */
    renderRequirements = () => {

        if (!this.constructor.HasRequirements) {
            return null;
        }
        return (
            <Alert showIcon={!this.isRequirementOptional()}
                   message={this.requirementInfo()}
                   type={this.isRequirementOptional() ? undefined : (this.isRequirementComplete() ? 'success' : 'warning')}
                   style={{fontSize: 13, lineHeight: '14px'}}
                   className={TB.mapClass("[&>.ant-alert-icon]:mt-[-1px] mx-auto md:ml-auto md:mr-0", {
                       "bg-gray-300 border border-gray-300": this.isRequirementOptional(),
                       "border-[#FFB946]": !this.isRequirementOptional() && !this.isRequirementComplete(),
                       "border-[#5ae399]": !this.isRequirementOptional() && this.isRequirementComplete(),
                   })}
            />
        )
    }


}